import { render, staticRenderFns } from "./BaseRatingPicker.vue?vue&type=template&id=0e08f634"
import script from "./BaseRatingPicker.vue?vue&type=script&lang=js"
export * from "./BaseRatingPicker.vue?vue&type=script&lang=js"
import style0 from "./BaseRatingPicker.vue?vue&type=style&index=0&id=0e08f634&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports